import { Browser, OpenOptions } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export abstract class BrowserHelper {
  public static open(options: OpenOptions): Promise<void> {

    if (Capacitor.isNativePlatform()) {
      return Browser.open(options);
    }

    return new Promise<void>((resolve) => {
      // workaround necessary to allow Safari iOS navigation
      // https://dontpaniclabs.com/blog/post/2025/07/29/understanding-window-open-behavior-on-ios-safari/
      setTimeout(() => {
        window.open(options.url, '_system');
        resolve();
      }, 500);
    });
  }
}
